import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useGetCampaigns = (filters = {}) => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [isCampaignsLoading, setIsCampaignsLoading] = useState(false);

  const getCampaigns = useCallback(async () => {
    setIsCampaignsLoading(true);
    try {
      const token = localStorage.getItem("authToken");

      const params = {};
      if (filters.category) params.category = filters.category;
      if (filters.status) params.status = filters.status;
      
      const res = await axios.get(
        `/api/v1/phr-app/marketing-assets`,
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      setCampaigns(res.data || []);
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
        if (error.response?.data?.statusCode === 401) {
          localStorage.removeItem("authToken");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      }
      setCampaigns([]);
    } finally {
      setIsCampaignsLoading(false);
    }
  }, [filters.category, filters.status, navigate]);

  useEffect(() => {
    getCampaigns();
  }, [getCampaigns]);

  return {
    campaigns,
    isCampaignsLoading,
    getCampaigns,
  };
};

export default useGetCampaigns;

